import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Action, PostAction, PutAction } from 'src/app/interfaces/api/action';
import { QueryParams } from 'src/app/interfaces/shared/query';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../core/api.service';

@Injectable({
  providedIn: 'root',
})
export class ActionService {
  collection = 'Action';
  collectionPath = 'actions';
  apiUrl = environment.API_URL;

  constructor(private apiService: ApiService) { }

  //---GET---//

  getActions(query: QueryParams = {}): Observable<Action[]> {
    return this.apiService.getCollection(this.collectionPath, '', query);
  }

  getAction(id: string): Observable<Action> {
    return this.apiService.getCollectionItem(this.collectionPath, '', id);
  }

  getActionsByRisk(riskId: string): Observable<Action[]> {
    return this.apiService.getCollection(this.collectionPath, '', { risk: riskId });
  }

  getActionsCount(query: QueryParams = {}): Observable<number> {
    return this.apiService.getCollection(this.collectionPath, 'count', query);
  }

  //---POST---//

  addAction(action: PostAction): Observable<Action> {
    return this.apiService.postCollectionData(this.collectionPath, '', action);
  }

  //---PUT---//

  updateAction(action: PutAction): Observable<Action> {
    return this.apiService.updateCollection(this.collectionPath, '', action);
  }

  //---DELETE---//

  removeAction(id: string): Observable<any> {
    return this.apiService.deleteCollectionItem(this.collectionPath, id);
  }
}
